<template>
  <dialog-reset height="75vh" top="5vh" width="80%" title="选择设备" :visible.sync="visible">
    <avue-crud v-if="visible" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :permission="permissionList" :before-open="beforeOpen" v-model="form" ref="crudSub" @row-update="rowUpdate"
      @row-save="rowSave" @row-del="rowDel" @search-change="searchChange" @search-reset="searchReset" @selection-change="selectionChange" @current-change="currentChange" @size-change="sizeChange" @refresh-change="refreshChange"
      @row-dblclick="rowDblClick" @on-load="onLoad">
      <template slot-scope="{ row }" slot="timeAndUser">
        <div>{{ row.updateName }}</div>
        <div>{{ row.updateTime }}</div>
      </template>
    </avue-crud>
  </dialog-reset>
</template>
<script>
import crudMixins from "@/mixins/crud-mixins";
import { getDeviceList } from "../api";
import { searchTimeConfig } from "@/basic-common/util/common";

export default {
  mixins: [crudMixins],
  name: 'SelectContract',
  data () {
    const that = this
    return {
      apiConfig: { getList: getDeviceList },
      defaultParams: {
        //  businessType: "1",
      },
      visible: false,
      query: {},
      option: {
        cancelHijack: true,
        maxHeight: '380',
        searchShow: true,
        searchSpan: 6,
        searchMenuSpan: 24,
        searchMenuPosition: 'right',
        menu: false,
        calcHeight: 30,
        tip: false,
        border: true,
        index: true,
        addBtn: false,
        viewBtn: true,
        dialogClickModal: false,
        searchLabelWidth: 90,
        indexLabel: '序号',
        align: 'center',
        labelWidth: 135,
        column: [

          // 表格显示字段
          {
            label: '设备分类',
            prop: 'category',
            search: true,
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=category",
            dicFormatter: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
            rules: [
              { required: true, message: "请选择设备类型", trigger: "change" },
            ],
          },
          {
            label: "设备名称",
            prop: "deviceName",
            width: 150,
            overHidden: true,
            search: true,
            type: "input",
            searchPlaceholder: "请输入设备名称",
            addDisplay: true,
            editDisplay: true,
            viewDisplay: true,
            rules: [
              { required: true, message: "请输入设备名称", trigger: "blur" },
              {
                min: 1,
                max: 50,
                message: "设备名称长度在1到50个字符",
                trigger: "blur",
              },
            ],
          },
          {
            label: "设备类型",
            prop: "deviceType",
            align: "center",
            search: true,
            width: 120,
            type: "select",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=base_device_type",
            dicFormatter: true,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "string",
            addDisplay: true,
            editDisplay: true,
            viewDisplay: true,
            rules: [
              { required: true, message: "请选择设备类型", trigger: "change" },
            ],
          },
          {
            label: "设备型号",
            prop: "deviceModel",
            align: "center",
            width: 100,
          },
          {
            label: '经度',
            prop: 'longitude',
          },
          {
            label: '纬度',
            prop: 'latitude',
          },
          {
            label: '采购日期',
            prop: 'purchaseDate',
            type: 'datetime',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: "运行状态",
            prop: "operationStatus",
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=device_status",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
          },
          {
            label: '更新时间',
            prop: 'updateTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 120,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '备注',
            prop: 'remark',
            maxlength: 50,
            type: "textarea",
            span: 24,
            minRows: 3,
          },
          {
            label: "创建人",
            prop: "createName",
            align: "center",
            width: 100,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
          },
          {
            label: '创建时间',
            prop: 'createTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 120,
            addDisplay: false,
            editDisplay: false,
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
    }
  },
  created () { },
  methods: {
    open () {
      this.visible = true
    },
    //  提交
    rowDblClick (item) {
      //  带出通知
      this.$emit('replace', item,)
      this.visible = false
    },

  },
}
</script>
<style lang="scss" scoped>
::v-deep .avue-crud__menu {
  display: none;
}
</style>

